import styled, {css} from 'styled-components';
import {DatePickerStyleProps} from '../../../../DatePicker.types';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;

	width: 100%;

	${({theme}) => css`
		${theme.breakpoints.up('sm')} {
			border-top: 0;
		}
	`}
`;

const Content = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-top: ${({theme}) => theme.spacing('3x')};

	margin: 0 auto;

	${({theme}) => css`
		@media ${theme.breakpoints.values.lg} {
			max-width: 100%;
			margin: 0;
			padding: 0;
		}
	`}
`;

const Title = styled.span`
	font-size: 16px;
	font-weight: 600;
	${({theme}) => css`
		color: ${theme.colors.light.text.primary};
	`}
`;

const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	gap: ${({theme}) => theme.spacing('2x')};
`;

const DividerHeader = styled.div<DatePickerStyleProps>`
	width: 0.5px;
	height: 28px;
`;

const ButtonActionCalendar = styled.button`
	border: 0;
	background: transparent;
	cursor: pointer;

	width: 40px;
	height: 40px;

	display: flex;
	align-items: center;
	justify-content: center;

	&:disabled {
		opacity: 0.5;
	}

	${({theme}) => css`
		&:focus {
			border-radius: 4px;
			outline: 6px solid rgba(2, 108, 182, 0.2);
			border: 2px solid ${theme.colors.brand.primary.blue};
		}
	`}
`;

export {Container, Content, Title, ButtonContainer, DividerHeader, ButtonActionCalendar};
